module.exports = __webpack_public_path__ + "img/ShotaArveladze.5c806f2e.webp";